// eslint-disable @typescript-eslint/no-unused-vars

import moment from 'moment'
import { isEmpty } from 'lodash'

import { DAY_FIRST_DATE_FORMAT } from 'lib/GlobalConstants'
import { FilterItem } from 'types/FilterBuilder'

export const populateDataByKey = (array: any = [], key: any) => {
  // fetch data needed from array for request object
  return Array.isArray(array) && array?.map((v: typeof key) => v?.[key])
}

export const ifNoneSelection = (
  data: any = [],
  flagName: string,
  valueArrayName: string,
) => {
  const isNoneSeelctionPresent = data?.includes(0)

  return {
    [flagName]: isNoneSeelctionPresent,
    [valueArrayName]: isNoneSeelctionPresent ? [] : data,
  }
}

const formatAndSetDateRangeFilter = (item: FilterItem) => {
  const { startDate, endDate } = item.dateRange || {}

  return {
    date_range: {
      start_date: moment(startDate).format(DAY_FIRST_DATE_FORMAT),
      end_date: moment(endDate).format(DAY_FIRST_DATE_FORMAT),
    },
  }
}

const setPageFilter = (item: FilterItem) => {
  const projectPageFilter = populateDataByKey(item.value, 'id')
  if (isEmpty(projectPageFilter)) return {}

  return {
    page_type: ifNoneSelection(projectPageFilter, 'select_none', 'ids'),
  }
}

const setFilters = (filterName: string, item: FilterItem, value: string) => {
  return {
    [filterName]: populateDataByKey(item.value, value),
  }
}

export const prepareFilters = (filters: FilterItem[]) => {
  let preparedFilters = {}
  let filterData = {}

  filters.forEach((filter: FilterItem) => {
    switch (filter.name) {
      case 'dateRange':
        filterData = formatAndSetDateRangeFilter(filter)
        break
      case 'page':
        filterData = setPageFilter(filter)
        break
      case 'projectStatus':
        filterData = setFilters('project_status', filter, 'key')
        break
      case 'projectTag':
        filterData = setFilters('project_tag_ids', filter, 'id')
        break
      case 'projects':
        filterData = setFilters('project_ids', filter, 'id')
        break
      case 'hub':
        filterData = setFilters('hub_ids', filter, 'id')
        break
      case 'participantType':
        filterData = setFilters('participant_types', filter, 'key')
        break
      case 'participantsGroups':
        filterData = setFilters('participant_group_ids', filter, 'id')
        break
      case 'dashboardLocation':
        filterData = setFilters('locations', filter, 'location')
        break
      case 'yearOfBirth':
        filterData = setFilters('year_of_birth', filter, 'year')
        break
      case 'ethnicity':
        filterData = setFilters('ethnicity', filter, 'id')
        break
      case 'gender':
        filterData = setFilters('gender', filter, 'id')
        break
      default:
        break
    }

    preparedFilters = {
      ...preparedFilters,
      ...filterData,
    }
  })

  return { filters: preparedFilters }
}
